import { useState } from "react";
import Modal from "./Modal";

const VerifyEmailModal = ({ isOpen, onClose, onVerify }) => {
	const [otp, setOtp] = useState("");
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!otp) return;
		
		setSubmitting(true);
		setError(null);
		
		try {
			await onVerify(otp);
			setOtp(""); // Clear on success
		} catch (err) {
			setError(err.message || "Verification failed");
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Verify Email Change">
			<form onSubmit={handleSubmit} className="flex flex-col gap-4">
				<p className="text-gray-600">
					Please enter the verification code sent to your new email address.
				</p>
				
				<div className="flex flex-col gap-2">
					<input
						type="text"
						value={otp}
						onChange={(e) => setOtp(e.target.value)}
						placeholder="Enter verification code"
						className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-center text-xl tracking-widest"
						maxLength={6}
					/>
					{error && <p className="text-red-500 text-sm">{error}</p>}
				</div>

				<button
					type="submit"
					disabled={submitting}
					className="w-full py-3 px-6 rounded-lg font-bold text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 transition-colors"
				>
					{submitting ? "Verifying..." : "Verify Code"}
				</button>
			</form>
		</Modal>
	);
};

export default VerifyEmailModal;
